import { platformFeatures } from '@/mocks/home';

export default function PlatformFeaturesSection() {
  return (
    <section id="features" className="relative py-16 md:py-20 bg-primary-950 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-500/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-500/20 to-transparent"></div>

      <div className="w-full px-4 md:px-10 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs md:text-sm text-secondary-400 tracking-[0.3em] uppercase font-medium">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-background-50 mt-3">
            歪歪漫画
          </h2>
          <p className="font-heading text-xl md:text-3xl font-bold text-background-50/80 mt-1">
            你的专属韩漫基地
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 md:mt-12">
            <a
              href="#hot"
              className="px-8 py-3 rounded-full bg-background-50 text-primary-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即进入漫画库
            </a>
            <a
              href="#hot"
              className="px-8 py-3 rounded-full text-sm md:text-base font-medium text-background-50 border border-background-50/30 hover:border-background-50/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览热门排行
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4 max-w-5xl mx-auto mt-14 md:mt-16">
          {platformFeatures.map((feature) => (
            <div
              key={feature.id}
              className="relative rounded-xl bg-primary-900/60 border border-primary-800/40 p-5 md:p-6 text-left group hover:bg-primary-900/80 hover:border-accent-500/30 transition-all duration-300 cursor-default"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-800/50 mb-3 md:mb-4 group-hover:bg-accent-500/20 transition-colors duration-300">
                <i className={`${feature.icon} text-lg md:text-xl text-background-50/80 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-background-50 mb-1.5 whitespace-nowrap">
                {feature.title}
              </h4>
              <p className="text-xs text-secondary-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}